/*
 * @Author: 刑天
 * @Date: 2022-04-15 10:18:49
 * @LastEditTime: 2023-12-28 14:06:04
 * @Description: 战神
 */
import * as activityFission from '../services/activityFission';

export default {
  namespace: 'activityFission',

  state: {
    appointActivityList: [],
    total: 1,
    baseDataDefaultValues: {},
  },

  effects: {
    *getFissionActivitiesPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        activityFission.getFissionActivitiesPage,
        values,
      );
      if (callback) {
        return callback(response?.data?.data);
      }
      yield put({
        type: 'save',
        payload: {
          appointActivityList: response?.data?.data,
          total: response?.data?.total,
        },
      });
    },
    *queryFissionRankingReport({ payload: { values } }, { call, put }) {
      const response = yield call(
        activityFission.queryFissionRankingReport,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          appointActivityReportList: response?.data?.data,
          reportTotal: response?.data?.total,
        },
      });
    },
    *terminateActivityFission({ payload: { values }, callback }, { call }) {
      const response = yield call(
        activityFission.terminateActivityFission,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *approveActivityFission({ payload: { values }, callback }, { call }) {
      const response = yield call(
        activityFission.approveActivityFission,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *insertAndUpdateActivityFission({ payload: { values }, callback }, {call}) {
      const res = yield call(activityFission.insertAndUpdateActivityFission, values);
      return callback(res?.code);
    },
    *getActivityFissionDetail({ payload: { values }, callback }, {call, put}) {
      const res = yield call(activityFission.getActivityFissionDetail, values);
      yield put({
        type: 'save',
        payload: {
          baseDataDefaultValues: res.data,
        },
      });
      return callback(res?.code);
    },
    *deleteActivity({ payload: { values }, callback }, {call}) {
      const res = yield call(activityFission.deleteActivityFission, values);
      return callback(res?.code);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname === '/marketing/app_activity_fission/app_activity_fission_add'||props.pathname === '/marketing/app_activity_fission/app_activity_fission_edit'||props.pathname === '/marketing/app_activity_fission/app_activity_fission_detail') {
          dispatch({
            type: 'save',
            payload: {
              baseDataDefaultValues: {},
            },
          });
        }
      });
    },
  },
};
